import React from "react";

import { isRenewal } from "QuotePage/urls";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import { calendlyURL, calendlyRenewalsURL } from "ZeroRuby/urls";

import { ReduxTrigger, Modal, ModalBody, ModalHeader } from "Cobalt/Modal";
import AgentImg from "Common/Agent/AgentImg";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Row, Col } from "Common/Grid";
import Header from "Cobalt/Header";
import Icon from "Common/Icon";

import { RecommendationSurveyStandaloneTrigger } from "./shared/RecommendationSurveyCard";

class ConsultPlanRecommendationModal extends React.Component {
  handleShow = () => {
    if (this.props.onShow) {
      this.props.onShow();
    }
  };

  handleHide = (reduxTriggerProps) => () => {
    reduxTriggerProps.onHide("consultationModal");
    if (this.props.onHide) {
      AnalyticsTracking.trackEvent("modal_closed", {
        location: "consult_plan_recommendation_modal",
      });

      this.props.onHide();
    }
  };

  render() {
    return (
      <ReduxTrigger
        name="consultationModal"
        modal={(props) => (
          <Modal show={props.show} onShow={this.handleShow} onHide={this.handleHide(props)}>
            <ModalHeader closeButton>
              <Header level={7}>Book a Consultation</Header>
            </ModalHeader>
            <ModalBody>
              <>
                <Row pb={4}>
                  <Col md={1}>
                    <AgentImg size="tiny" />
                  </Col>
                  <Col md={11}>
                    <BodyText>
                      Our virtual insurance agent, Leigh, can recommend a plan if you take a 5-question survey. Otherwise, you can proceed to contact one of our
                      live agents.
                    </BodyText>
                  </Col>
                </Row>
                <Row mb={3}>
                  <Col>
                    <RecommendationSurveyStandaloneTrigger location="consultation_modal" onSubmitModalCallback={props} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      color="link"
                      px={1}
                      onClick={() => {
                        window.Calendly.initPopupWidget({
                          url: isRenewal() ? calendlyRenewalsURL() : calendlyURL(),
                          prefill: {
                            name: this.props.contactName,
                            email: this.props.companyEmail,
                          },
                        });

                        AnalyticsTracking.trackEvent("cta_clicked", {
                          location: "consultation_modal",
                          feature: "contact_us_modal",
                          type: "calendly_link_clicked",
                          is_renewal: isRenewal(),
                        });
                      }}
                    >
                      <Icon icon="phone" pr={2} flavor="solid" />
                      Book a 30 Minute Consultation
                    </Button>
                  </Col>
                </Row>
              </>
            </ModalBody>
          </Modal>
        )}
      />
    );
  }
}

export default ConsultPlanRecommendationModal;
